<template>
  <b-form-group
    id="input-group-1"
    :label="`${label || 'Foto: '} ${state.file && !state.url ? state.file.name : ''}`"
    label-for="input-1"
  >
    <b-button
      type="button"
      variant="outline-dark"
      target="_blank"
      :href="state.url"
      v-if="state.url && isDoc"
    >
      <b-icon-eye></b-icon-eye>&nbsp;Ver Arquivo
    </b-button>
    <b-avatar v-else-if="state.url && !isDoc" :src="state.url" size="lg"></b-avatar>

    <button type="button" @click="() => remove()" class="btn btn-danger" v-if="state.url">
      <b-icon-trash></b-icon-trash>&nbsp;Remover
    </button>
    <div class="example-btn" v-else>
      <file-upload
        class="btn btn-secondary"
        post-action="/api/upload/"
        :extensions="extensions || 'gif,jpg,jpeg,png,webp'"
        :accept="accept || 'image/png, image/gif, image/jpeg, image/webp'"
        :multiple="false"
        :size="1024 * 1024 * 10"
        v-model="state.files"
        @input-filter="inputFilter"
        @input-file="inputFile"
        ref="upload"
      >
        <b-icon-plus></b-icon-plus>
        <span>{{state.file ? 'Alterar' : 'Adicionar'}}</span>
      </file-upload>

      <button
        type="button"
        class="btn btn-success"
        v-if="this.state.file"
        @click.prevent="$refs.upload.active = true"
      >
        <b-spinner v-if="viewData.loading" small></b-spinner>
        <span v-else>
          <b-icon-upload></b-icon-upload>&nbsp;Upload
        </span>
      </button>
      <button
        type="button"
        @click="() => this.remove()"
        class="btn btn-danger"
        v-if="this.state.file"
      >
        <b-icon-trash></b-icon-trash>&nbsp;Remover
      </button>
    </div>
  </b-form-group>
</template>

<style>
.example-simple label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
}
</style>

<script>
import helpers from '../vue/helpers';

import FileUpload from 'vue-upload-component';
let self = null;

export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      state: {
        files: [],
        file: null,
        url: '',
      },
      viewData: {
        loading: false,
      },
    };
  },
  beforeMount() {
    this.state.url = this.currentUrl;
  },
  mounted() {
    self = this;
  },
  methods: {
    remove() {
      this.state.file = null;
      this.state.url = null;
      this.updateUrl(null);
    },
    inputFilter(newFile, oldFile, prevent) {},
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        this.state.file = newFile;
      }
      if (newFile && oldFile) {
        this.state.file = newFile;
      }
      if (!newFile && oldFile) {
        this.state.file = null;
      }

      if (newFile && newFile.xhr) {
        if (newFile.xhr.status > 0 && newFile.xhr.status !== 200) {
          this.$toast.error(
            helpers.getFirstError(JSON.parse(newFile.xhr.response)),
          );
          this.viewData.loading = false;
          this.setLoading(false);
        } else if (newFile.xhr.status === 0) {
          this.viewData.loading = true;
          this.setLoading(true);
        } else {
          this.viewData.loading = false;
          this.state.url = JSON.parse(newFile.xhr.response).model;
          this.updateUrl(this.state.url);
          this.setLoading(false);
        }
      } else {
        this.viewData.loading = false;
        this.setLoading(false);
      }
    },
  },
  props: [
    'updateUrl',
    'setLoading',
    'currentUrl',
    'label',
    'accept',
    'extensions',
    'isDoc',
  ],
};
</script>